(function () {
  if (customElements.get('cart-drawer')) return

  customElements.define(
    'cart-drawer',
    class CartDrawer extends HTMLElement {
      connectedCallback () {
        this.panel = this.querySelector('.cd-panel')
        this.onKey = (e) => {
          if (!this.classList.contains('is-open')) return
          if (e.key === 'Escape') this.close()
          if (e.key === 'Tab') this.keepFocus(e)
        }
        document.addEventListener('keydown', this.onKey)
        /* Complete the look: from inside the drawer just re-render; from the product page
         re-render and slide it open. The cart page handles its own (it reloads). */
        document.addEventListener('cart-upsell:added', (e) => {
          const inside = e.target.closest('cart-drawer') === this
          if (!inside && document.querySelector('cart-items')) return
          this.renderContents(e.detail)
          if (!inside) this.open()
          else if (this.panel) this.panel.focus() /* the Add button is gone after the swap */
        })
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-cd-close]')) {
            this.close()
            return
          }
          const step = e.target.closest('[data-cd-step]')
          if (step) {
            const item = step.closest('[data-cd-line]')
            const input = item.querySelector('[data-cd-input]')
            this.change(
              item,
              Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.cdStep, 10))
            )
            return
          }
          const drop = e.target.closest('[data-cd-remove]')
          if (drop) this.change(drop.closest('[data-cd-line]'), 0)
        })
        this.addEventListener('change', (e) => {
          const input = e.target.closest('[data-cd-input]')
          if (input) {
            this.change(
              input.closest('[data-cd-line]'),
              Math.max(0, parseInt(input.value, 10) || 0)
            )
          }
        })
      }

      open () {
        this.opener = document.activeElement
        this.classList.add('is-open')
        this.setAttribute('aria-hidden', 'false')
        document.body.classList.add('overflow-hidden')
        this.panel.focus()
      }

      close () {
        this.classList.remove('is-open')
        this.setAttribute('aria-hidden', 'true')
        document.body.classList.remove('overflow-hidden')
        if (this.opener && this.opener.focus) this.opener.focus()
        this.opener = null
      }

      keepFocus (e) {
        const focusable = this.panel.querySelectorAll(
          'a[href], button:enabled, select:enabled, textarea:enabled, input:not([type=hidden]):enabled, [tabindex]:not([tabindex^="-"])'
        )
        if (!focusable.length) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault()
          last.focus()
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault()
          first.focus()
        }
      }

      getSectionsToRender () {
        return [{ id: 'cart-drawer' }]
      }

      change (item, quantity) {
        if (!item) return
        const variant_title = item.dataset.cdVariant
        item.classList.add('is-busy')
        fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: item.dataset.cdLine,
            quantity,
            sections: this.getSectionsToRender()
              .map((section) => section.id)
              .join(','),
            sections_url: window.location.pathname
          })
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) {
              this.warn(item, state.description || state.message)
              return
            }
            /*
               When more units are requested than exist, Shopify does not return
               an error: it trims the quantity and answers 200. Without this the
               number changed on its own and nobody knew why.
          */
            const line = (state.items || []).filter(function (i) {
              return String(i.id) === String(variant_title)
            })[0]
            const inStock = line ? line.quantity : 0
            this.renderContents(state)
            if (quantity > 0 && inStock < quantity) {
              this.warnVariant(
                variant_title,
                inStock > 0 ? 'Only ' + inStock + ' left in stock.' : 'That one just sold out.'
              )
            }
          })
          .catch(() => {
            this.warn(item, 'We could not update the cart. Please try again.')
          })
          .finally(() => {
            item.classList.remove('is-busy')
          })
      }

      warnVariant (variantId, text) {
        const line = this.querySelector('[data-cd-variant="' + variantId + '"]')
        if (line) this.warn(line, text)
      }

      warn (item, text) {
        const slot = item.querySelector('[data-cd-warn]')
        if (!slot) return
        slot.textContent = text
        slot.hidden = false
        const input = item.querySelector('[data-cd-input]')
        if (input) input.value = input.defaultValue
      }

      syncBadges () {
        const count = Number(this.panel.dataset.count) || 0
        document.querySelectorAll('[data-cart-count]').forEach((node) => {
          node.textContent = count
          node.hidden = count === 0
        })
      }

      addItem (id, quantity, properties) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
        const sections = this.getSectionsToRender()
          .map((section) => section.id)
          .join(',')
        const post = (url, body) =>
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(Object.assign(body, { sections, sections_url: window.location.pathname }))
          }).then((response) => response.json())
        return fetch(root + 'cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const line = (cart.items || []).find(function (item) {
              return (
                item.variant_id === Number(id) &&
                Object.keys(item.properties || {}).every(function (key) {
                  return key.charAt(0) === '_'
                })
              )
            })
            if (line) {
              return post(window.routes.cart_change_url + '.js', {
                id: line.key,
                quantity: line.quantity + quantity
              })
            }
            return post(window.routes.cart_add_url + '.js', {
              items: [{ id: Number(id), quantity, properties: properties || {} }]
            })
          })
      }

      renderContents (state) {
        const html = state.sections && state.sections['cart-drawer']
        if (html) {
          const holder = document.createElement('template')
          holder.innerHTML = html
          const fresh = holder.content.querySelector('cart-drawer')
          if (fresh) {
            this.innerHTML = fresh.innerHTML
            this.panel = this.querySelector('.cd-panel')
          }
        }
        this.syncBadges()
        document.dispatchEvent(new CustomEvent('cart:updated'))
      }
    }
  )

  document.addEventListener('click', function (e) {
    const link = e.target.closest(
      'a[href$="/cart"]:not(.cd-view), a[href$="/cart/"]:not(.cd-view), [data-cart-drawer-open]'
    )
    if (!link) return
    const drawer = document.querySelector('cart-drawer')
    if (!drawer) return
    e.preventDefault()
    drawer.open()
  })
})()
